import clienteService from '../../services/ClienteService'
async function carregarCliente(context, paylad) {
   const cliente = await clienteService.obterClientePorApelido(paylad);
   context.commit('ADD_CLIENTE_FORMULARIO', cliente)
}


export default {
   carregarCliente
}


// WEBPACK FOOTER //
// ./src/store/actions/cliente.action.js